module.exports = __webpack_public_path__ + "static/media/hyper.9ac22d55.png";